module.exports = __webpack_public_path__ + "static/media/laptop-promo-high.4c4efba8.png";